import React, { useState, useCallback } from 'react';
import Code from '../../Code/Code';
import EmbedCodeCopyButton from '../../EmbedCodeCopyButton/EmbedCodeCopyButton';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';
import ComboBox from '../../../../components/ComboBox/ComboBox';
import getHostUrlForIntegrations from '../../../../../services/mini/getHostUrlForIntegrations';

const htmlCodeMirrorOptions = {
    lineNumbers: false,
    readOnly: true,
    mode: {
        name: 'javascript',
    },
    scrollbarStyle: null,
    cursorScrollMargin: -1000,
};

const FlutterCliInstallCode = 'alan_voice: 3.0.0';

const FlutterCliImportCode = 'import \'package:alan_voice/alan_voice.dart\';';

function getFlutterCode(alanKey, codeMode) {
    if (codeMode === 'simple') {
      return `_MyHomePageState() {
  /// Init Alan Button with project key from Alan AI Studio      
  AlanVoice.addButton("${alanKey}", server:"${getHostUrlForIntegrations()}");

  /// Handle commands from Alan AI Studio
  AlanVoice.onCommand.add((command) {
    debugPrint("got new command \${command.toString()}");
  });
}`;
    } else {
      return `_MyHomePageState() {
  /// Init Alan Button with project key and additional params
  var authData = jsonEncode({"data":"your auth data if needed"});
  AlanVoice.addButton("${alanKey}", server:"${getHostUrlForIntegrations()}", authJson: authData);

  /// Handle commands from Alan AI Studio
  AlanVoice.onCommand.add((command) {
    debugPrint("got new command \${command.toString()}");
  });
          
  /// Handle button state
  AlanVoice.onButtonState.add((state) {
    debugPrint("got new button state \${state.name}");
  });

  /// Handle events
  AlanVoice.onEvent.add((event) {
    debugPrint("got new event \${event.data.toString()}");
  });

  /// Activate Alan Button programmatically
  void _activate() {
    AlanVoice.activate();
  }

  /// Deactivate Alan Button programmatically
  void _deactivate() {
    AlanVoice.deactivate();
  }

  /// Play any text via Alan Button
  void _playText() {
    /// Provide text as string param
    AlanVoice.playText("Hi");
  }

  /// Execute any command locally
  void _playCommand() {
    /// Provide any params with json
    var command = jsonEncode({"action":"openSomePage"});
    AlanVoice.playCommand(command);
  }

  /// Call projectAPI.funcName from Alan AI Studio script
  void _callProjectApi() {
    /// Provide any params with json
    var params = jsonEncode({"data":"your data"});
    AlanVoice.callProjectApi("script::funcName", params);
  }

  /// Set up a visual state
  void _setVisualState() {
    /// Provide any params with json
    var visualState = jsonEncode({"data":"your data"});
    AlanVoice.setVisualState(visualState);
  }
}`;
    }
}

const codeModes = [
  { name: 'Simple Example', key: 'simple' },
  { name: 'Advanced Example', key: 'advanced' }
];

export function FlutterTab({ alanKey }) {

    const [codeMode, setCodeMode] = useState('simple');

    const changeCodeModeCb = useCallback((codeModeObj) => {
      setCodeMode(codeModeObj.key);
    }, []);

    return <div className="embed-code-tab">
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description">
            </div>
            <div className="embed-code-tab_dash"></div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_not-highlighted-code">
                    <Code>
                        {
                            '\n'
                        }
                    </Code>
                </div>
            </div>

        </div>
        <ComboBox values={codeModes}
            valueKey="key"
            valueName="name"
            classes="code-mode-combo-box light-blue-with-border"
            selectedValueId={codeMode}
            onValueSelect={changeCodeModeCb}
            renderItem={(codeModeItem) => {
                return <div style={{ paddingLeft: '8px' }}
                    key={codeModeItem.key}>
                    {codeModeItem.name}
                </div>;
            }} />


        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc4">
                Add the Alan dependency
            </div>
            <div className="embed-code-tab_dash embed-code-desc4">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted category="Flutter" type="code">
                        {FlutterCliInstallCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={FlutterCliInstallCode} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc4">
                Import the Alan package
            </div>
            <div className="embed-code-tab_dash embed-code-desc4">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <ReactCodeMirror
                        value={FlutterCliImportCode}
                        options={htmlCodeMirrorOptions} />
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={FlutterCliImportCode} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc4">
                Add Alan button
            </div>
            <div className="embed-code-tab_dash embed-code-desc4">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <ReactCodeMirror
                        value={getFlutterCode(alanKey, codeMode)}
                        options={htmlCodeMirrorOptions} />
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={getFlutterCode(alanKey, codeMode)} />
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
